module.exports = __webpack_public_path__ + "static/img/share-earn2.7dc488ce.png";